const reCaptchaData = (state = {}, action) => {
  switch (action.type) {
    case 'SET_RECAPTCHA_DATA':
      return { ...state, ...action.data }

    default:
      return state
  }
}

export default reCaptchaData
